
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Henri-Paul Cornu, 71, verstorben am 26. März 2020</b>
    <br />
    <br />
    <i>Tochter Céline Fleury-Cornu erzählt:</i>
    <br />
    <p>
  «Am 25. März habe ich am Telefon Abschied von meinem Vater Henri-Paul
  genommen. Er lag auf der Intensivstation des Kantonsspitals Freiburg, schwer
  an Covid-19 erkrankt. Wir wussten, dass er sterben wird. Doch eine Reise quer
  durch die Schweiz schien mir zu dem Zeitpunkt viel zu riskant. Ich lebe mit
  meinem Mann und den drei Kindern in Zürich.
    </p>
    <p>
  Zum einen hatte ich Angst, mich ebenfalls anzustecken, zum anderen fürchtete
  ich mich vor den Bildern: mein Vater auf der Intensivstation, all die Menschen
  um ihn herum, die Maschinen, die Hektik.
    </p>
    <p>
  So telefonierten wir mit ihm, wir sassen zu fünft vor dem Telefon. Es sprach
  vor allem ich. Ein bisschen auch unsere jüngste Tochter. Unsere anderen beiden
  Töchter und mein Mann Pascal schluchzten nur. Es war ihnen nicht möglich zu
  reden.
    </p>
    <p>
  Ich sagte meinem Vater, er solle sich keine Sorgen machen. Er könne loslassen
  und in Ruhe gehen. Dass wir ihn lieben. Auch meine jüngste Tochter sagte ihm
  das. Es war einfach schrecklich, für uns alle. Unfassbar traurig.
    </p>
    <p>
  Mein Vater sagte nicht viel und war wegen seiner Atemprobleme auch schwer zu
  verstehen. Einmal hörte ich, wie er sagte: ‹C’est dur.› ‹Es ist hart.› Er
  sagte auch, seine Beerdigung werde wohl verlaufen wie jene in Italien. Sehr
  schnell, ohne Zeremonie, ohne Besucher. Er hatte zuvor Zeitungsberichte
  gelesen und Fernsehbeiträge gesehen. Ich antwortete, das müsse ihn nicht
  beunruhigen. Wir kümmerten uns darum. Nach ein paar Minuten hängten wir auf.
    </p>
    <p>
  In der Nacht starb mein Vater. Am nächsten Tag hatte meine Mutter Anne-Lise
  Geburtstag, 69 Jahre wurde sie alt. Die beiden waren 50 Jahre verheiratet.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;